const linkedinEmbed = `<iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7480621740323147776?collapsed=1" height="669" width="504" frameborder="0" allowfullscreen="" title="Publicación integrada"></iframe>`;

export default function LinkedInFeed() {
  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden h-full">
      {/* Encabezado */}
      <div className="flex items-center justify-between px-5 md:px-6 py-3 md:py-4 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-[#0A66C2] flex items-center justify-center text-white text-lg">
            <i className="ri-linkedin-fill" />
          </div>
          <div>
            <span
              className="text-masmed-gray-800 text-base md:text-lg"
              style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 600 }}
            >
              LinkedIn
            </span>
            <p className="text-masmed-gray-400 text-xs">MásMed Tarapacá</p>
          </div>
        </div>
        <a
          href="https://www.linkedin.com/company/masmed-tarapaca"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-4 py-2 bg-[#0A66C2] text-white text-sm rounded-md hover:opacity-90 transition-opacity duration-200 cursor-pointer whitespace-nowrap"
          style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 600 }}
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-linkedin-fill" />
          </span>
          Seguir
        </a>
      </div>

      {/* Post embebido */}
      <div className="p-4 md:p-5 bg-masmed-gray-50 flex justify-center">
        <div
          className="w-full max-w-[504px]"
          dangerouslySetInnerHTML={{ __html: linkedinEmbed }}
        />
      </div>
    </div>
  );
}